<template>
  <v-app>
    
    <v-toolbar class="light-blue darken-1">
      <v-toolbar-side-icon @click.native.stop="drawerToggle = !drawerToggle"></v-toolbar-side-icon>
      <v-toolbar-title>
        <router-link to="/chat/0" tag="span" style="cursor: pointer">msp22 Chat</router-link>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items v-for="item in menuItems" :key="item.title">
        <v-btn flat :key="item.title" :to="item.route">
          <v-icon left>{{ item.icon }}</v-icon>
          <div class="hidden-xs-only">{{ item.title }}</div>
        </v-btn>
      </v-toolbar-items>
    </v-toolbar>
    
    
    <main>
      <router-view></router-view>
    </main>
    
  </v-app>
</template>

<script>
  export default {
    data () {
      return {
        drawerToggle: false
      }
    },
    computed: {
      menuItems () {
        let items = [
          // { icon: 'face', title: 'Register', route: '/register' },
          { icon: 'lock_open', title: 'Login', route: '/login' }
        ]
        if (this.userIsAuthenticated) {
          items = [
            { icon: 'chat', title: 'Create private Chat', route: '/private' },
            { icon: 'chat', title: 'Create public Chat', route: '/public' }
          ]
        }
        return items
      },
      userIsAuthenticated () {
        return this.$store.getters.user !== null && this.$store.getters.user !== undefined
      },
      onlineUsers () {
        // console.log(this.$store.getters.onlineUsers)
        return this.$store.getters.onlineUsers
      }
    }
  }
</script>
